<section class="content public-registration">
  <div class="content-block">
    <div class="registration-shell">
      <div class="card card-patient-profile">
        <div class="profile-content">
          <img class="profile-img" [src]="resolvedPanelImage" alt="Foto del Paciente" />
          <div class="profile-text">
            <div class="profile-name">NUEVO PACIENTE</div>
            <div class="profile-subtext">Complete la informacion requerida</div>
          </div>
        </div>
      </div>

      <div class="result-card" *ngIf="createdPatientId">
        <div class="result-label">ID PACIENTE</div>
        <div class="result-value">{{ createdPatientId }}</div>
      </div>

      <div class="form-panel">
        <div class="card px-4 py-4">
          <form [formGroup]="userForm" autocomplete="off">
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>lock</mat-icon>
                DATOS DE ACCESO
              </div>
              <div class="descripcion-seccion">
                CREDENCIALES QUE USARA EL PACIENTE PARA INGRESAR AL SISTEMA
              </div>

              <div class="row">
                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                    <mat-label>USUARIO</mat-label>
                    <input formControlName="usr" matInput />
                  </mat-form-field>
                  <div *ngIf="userForm.get('usr')?.touched && userForm.get('usr')?.invalid" class="custom-error-below">
                    <small *ngIf="userForm.get('usr')?.hasError('required')" class="text-danger">EL NOMBRE DE USUARIO ES OBLIGATORIO.</small>
                    <small *ngIf="userForm.get('usr')?.hasError('pattern')" class="text-danger">SOLO LETRAS, NUMEROS, ESPACIOS, PUNTOS, GUIONES Y GUIONES BAJOS.</small>
                  </div>
                </div>

                <div class="col-md-8 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                    <mat-label>CORREO ELECTRONICO</mat-label>
                    <input formControlName="email" matInput />
                  </mat-form-field>
                  <div *ngIf="userForm.get('email')?.touched && userForm.get('email')?.invalid" class="custom-error-below">
                    <small *ngIf="userForm.get('email')?.hasError('required')" class="text-danger">EL CORREO ELECTRONICO ES OBLIGATORIO.</small>
                    <small *ngIf="userForm.get('email')?.hasError('pattern')" class="text-danger">INGRESE UNA DIRECCION DE CORREO VALIDA.</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>person</mat-icon>
                DATOS DEL PACIENTE
              </div>
              <div class="descripcion-seccion">
                INFORMACION GENERAL DE CONTACTO Y DOMICILIO DEL PACIENTE
              </div>

              <div class="row">
                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>NOMBRE(S)</mat-label>
                    <input formControlName="nombres" matInput />
                  </mat-form-field>
                  <div *ngIf="userForm.get('nombres')?.touched && userForm.get('nombres')?.invalid" class="custom-error-below">
                    <small *ngIf="userForm.get('nombres')?.hasError('required')" class="text-danger">EL CAMPO NOMBRES ES OBLIGATORIO.</small>
                    <small *ngIf="userForm.get('nombres')?.hasError('pattern')" class="text-danger">SOLO SE PERMITEN LETRAS Y ESPACIOS.</small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>PRIMER APELLIDO</mat-label>
                    <input formControlName="primerApellido" matInput />
                  </mat-form-field>
                  <div *ngIf="userForm.get('primerApellido')?.touched && userForm.get('primerApellido')?.invalid" class="custom-error-below">
                    <small *ngIf="userForm.get('primerApellido')?.hasError('required')" class="text-danger">EL PRIMER APELLIDO ES OBLIGATORIO.</small>
                    <small *ngIf="userForm.get('primerApellido')?.hasError('pattern')" class="text-danger">SOLO SE PERMITEN LETRAS Y ESPACIOS.</small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>SEGUNDO APELLIDO</mat-label>
                    <input formControlName="segundoApellido" matInput />
                  </mat-form-field>
                  <div *ngIf="userForm.get('segundoApellido')?.touched && userForm.get('segundoApellido')?.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO SE PERMITEN LETRAS Y ESPACIOS.</small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>TELEFONO MOVIL</mat-label>
                    <ngx-mat-intl-tel-input
                      formControlName="movil"
                      [preferredCountries]="preferredCountries"
                      [enablePlaceholder]="true">
                    </ngx-mat-intl-tel-input>
                  </mat-form-field>
                  <div *ngIf="userForm.get('movil')?.touched && userForm.get('movil')?.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL NUMERO DE CELULAR ES OBLIGATORIO.</small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>CODIGO POSTAL / COLONIA</mat-label>
                    <input
                      matInput
                      [matAutocomplete]="auto"
                      formControlName="settlementSearch"
                      (blur)="onSettlementBlur()"/>
                    <mat-autocomplete
                      #auto="matAutocomplete"
                      [displayWith]="displaySettlement"
                      (optionSelected)="setSelectedSettlement($event.option.value)">
                      <mat-option *ngFor="let option of settlements" [value]="option">
                        {{ option.asentamiento }}, {{ option.estado }} - CP: {{ option.codigoPostal }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <div *ngIf="userForm.get('settlementSearch')?.touched && userForm.get('settlementSearch')?.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL CODIGO POSTAL ES OBLIGATORIO.</small>
                  </div>
                </div>

                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>DIRECCION</mat-label>
                    <textarea formControlName="domicilio" matInput></textarea>
                  </mat-form-field>
                  <div *ngIf="userForm.get('domicilio')?.touched && userForm.get('domicilio')?.invalid" class="custom-error-below">
                    <small *ngIf="userForm.get('domicilio')?.hasError('required')" class="text-danger">EL DOMICILIO ES OBLIGATORIO.</small>
                    <small *ngIf="userForm.get('domicilio')?.hasError('pattern')" class="text-danger">SOLO SE PERMITEN LETRAS, NUMEROS Y CARACTERES . , _ # / - ( ).</small>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <form [formGroup]="patientForm" autocomplete="off">
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>fingerprint</mat-icon>
                DATOS ADICIONALES DEL PACIENTE
              </div>
              <div class="descripcion-seccion">
                INFORMACION OFICIAL RELEVANTE PARA LA IDENTIFICACION DEL PACIENTE
              </div>

              <div class="row">
                <div class="col-md-5 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>FECHA DE NACIMIENTO</mat-label>
                    <input [matDatepicker]="picker" formControlName="fechaNacimiento" matInput required>
                    <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <div *ngIf="patientForm.get('fechaNacimiento')?.touched && patientForm.get('fechaNacimiento')?.hasError('required')" class="custom-error-below">
                    <small class="text-danger">LA FECHA DE NACIMIENTO ES OBLIGATORIA.</small>
                  </div>
                </div>

                <div class="col-md-7 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>ENTIDAD DE NACIMIENTO</mat-label>
                    <mat-select formControlName="idEntidadNacimiento" required>
                      <mat-option *ngFor="let row of federalEntity" [value]="row.idEntidad">
                        {{ row.nombre }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="patientForm.get('idEntidadNacimiento')?.touched && patientForm.get('idEntidadNacimiento')?.hasError('required')" class="custom-error-below">
                    <small class="text-danger">LA ENTIDAD DE NACIMIENTO ES OBLIGATORIA.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>GENERO</mat-label>
                    <mat-select formControlName="idGeneroVisible" required>
                      <mat-option *ngFor="let row of generosVisibles" [value]="row.id">
                        {{ row.descripcion }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="patientForm.get('idGeneroVisible')?.touched && patientForm.get('idGeneroVisible')?.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL GENERO ES OBLIGATORIO.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>TIPO DE IDENTIFICACION</mat-label>
                    <mat-select formControlName="idTipoIdentificacion" (selectionChange)="onTipoIdentificacionChange()">
                      <mat-option [value]="ID_TIPO_IDENTIFICACION_SIN_ASIGNAR">SIN ASIGNAR</mat-option>
                      <mat-option [value]="ID_TIPO_IDENTIFICACION_PASAPORTE">PASAPORTE</mat-option>
                      <mat-option [value]="ID_TIPO_IDENTIFICACION_DOCUMENTO">{{ documentoIdentidadLabel }}</mat-option>
                      <mat-option [value]="ID_TIPO_IDENTIFICACION_REPRESENTANTE">{{ documentoRepresentanteLabel }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="patientForm.get('idTipoIdentificacion')?.touched && patientForm.get('idTipoIdentificacion')?.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL TIPO DE IDENTIFICACION ES OBLIGATORIO.</small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>NUMERO DE IDENTIFICACION</mat-label>
                    <input formControlName="numeroIdentificacion" matInput [readonly]="numeroIdentificacionReadonly" />
                  </mat-form-field>
                  <div *ngIf="patientForm.get('numeroIdentificacion')?.touched && patientForm.get('numeroIdentificacion')?.hasError('required') && !numeroIdentificacionReadonly" class="custom-error-below">
                    <small class="text-danger">EL NUMERO DE IDENTIFICACION ES OBLIGATORIO.</small>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <form [formGroup]="assetsForm" autocomplete="off">
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>settings</mat-icon>
                CONFIGURACION
              </div>
              <label class="upload-label">IMAGEN DE PERFIL (JPG, PNG, JPEG)</label>
              <app-file-upload
                formControlName="imagen"
                [acceptedTypes]="'image/*'"
                [circle]="true"
                [targetKB]="10"
                [initialMaxSize]="320">
              </app-file-upload>
            </div>

            <div class="seccion-formulario">
              <app-privacy-policies-consent
                formControlName="politicasPrivacidad"
                profileType="PACIENTE">
              </app-privacy-policies-consent>
            </div>

            <button
              class="button-custom"
              mat-button
              color="primary"
              [disabled]="submitting || userForm.invalid || patientForm.invalid"
              [ngClass]="{
                'disabled': submitting || userForm.invalid || patientForm.invalid
              }"
              (click)="submit()">
              {{ submitting ? 'ENVIANDO...' : 'REGISTRARME' }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
